import { Box, Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { t } from 'i18next';

type OperationStartPopupProps = {
  handleOk: () => void;
  onClose: () => void;
  isShow: boolean;
};

const OperationStartPopup: React.FC<OperationStartPopupProps> = ({ handleOk, onClose, isShow }) => {
  return (
    <Dialog
      open={isShow}
      onClose={onClose}
      className="operation-start-dialog"
      sx={{
        '& .MuiDialog-paper': {
          width: 'min(560px, calc(100vw - 32px))',
          maxWidth: '560px',
          margin: '16px',
          borderRadius: '20px',
          boxShadow: '0px 8px 24px 0px #00000021',
          backgroundColor: '#ffffff',
        },
      }}
    >
      <Box className="operation-start-modal">
        <DialogTitle className="operation-start-title">{t('driveDetail.runStartMessage')}</DialogTitle>
        <DialogActions className="operation-start-actions">
          <Button className="operation-start-button operation-start-button-no" onClick={onClose}>
            {t('driveDetail.no')}
          </Button>
          <Button className="operation-start-button operation-start-button-yes" onClick={handleOk}>
            {t('driveDetail.yes')}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default OperationStartPopup;
